<div class="overlay" [class.overlay--inline]="!fullScreen()" [style.zIndex]="zIndex()">
  <img class="spinner" src="assets/clear_2_loader.gif" />
  <span class="mt-3 color-prime-alt-grey" style="z-index: 1000">{{ loadingMessage() }}</span>
</div>
